const initialState = {
    isReadingQuotesAndOrders: false,
    entries: [],
    count: 0
}

export default initialState;
